import { render, staticRenderFns } from "./knowledge-experience.vue?vue&type=template&id=377f5d7f"
import script from "./knowledge-experience.vue?vue&type=script&lang=ts"
export * from "./knowledge-experience.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports